module.exports = __webpack_public_path__ + "images/emoji/x.4add3c5a7949161c02f9.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/x.png
// module id = r3MA
// module chunks = 1